// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://use.typekit.net/fes4uhy.css);"]);
// Module
exports.push([module.id, "@media (min-width:769px){.job-description-header__container{padding-top:60px;padding-bottom:60px}.job-description-header__right{flex:30 30 200px;justify-content:flex-end;align-items:center}.job-description-header__left{flex:70 70 400px}.job-description-header__fixed-header{justify-content:space-between}.job-description-header__fixed-header--button-container{flex-direction:row;flex:0}.job-description-header__fixed-header--button{width:166px}}", ""]);
// Exports
module.exports = exports;
